export default __webpack_public_path__ + "static/media/image23.faf3a108.jpg";